export default __webpack_public_path__ + "static/media/Talisman of the Ziggurat.594501f5.jpg";